import { Presentation, PresentationProperty } from '@raydiant/api-client-js';

const declaresPlaylist = (props: PresentationProperty[] | undefined): boolean =>
  (props ?? []).some(
    (prop) =>
      prop.type === 'playlist' ||
      (prop.type === 'array' && declaresPlaylist(prop.properties)),
  );

// True when the presentation's app renders other playlists inside it, as
// Multizone, Kiosk and Product Information Kiosk do. The app's schema says so:
// it declares a 'playlist'-typed property, at the top level or inside an
// 'array' property's items. A Signage Stick skips these presentations.
export const embedsPlaylists = (
  p: Pick<Presentation, 'presentationProperties'>,
): boolean => declaresPlaylist(p.presentationProperties);
